import React from 'react';
import Nav from './Nav';

type Props = {
  children: React.ReactNode;
};

export default function Layout({ children }: Props) {
  return (
    <>
      <Nav />
      <main style={{ flex: 1 }}>
        <div className="page-container">
          {children}
        </div>
      </main>
    </>
  );
}
